"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExploArtifactOptions = exports.ExploPlacement = void 0;
var ExploPlacement;
(function (ExploPlacement) {
    // Recall to update GQL type when updating this
    ExploPlacement.AllOptions = [
        // *** CF Specific Options ***
        'lenderFacilitiesTab',
        'borrowerStratsPage',
        // *** Org Level Options ***
        'lenderPortfolioTab',
    ];
    ExploPlacement.CreditFacilityOptions = [
        'lenderFacilitiesTab',
        'borrowerStratsPage',
    ];
    ExploPlacement.OrganizationOptions = ['lenderPortfolioTab'];
})(ExploPlacement = exports.ExploPlacement || (exports.ExploPlacement = {}));
exports.ExploArtifactOptions = ['dashboard', 'reportBuilder'];
//# sourceMappingURL=Explo.js.map